import React from 'react';
import { useParams } from 'react-router-dom';

import { useSxpContext } from '@futrli/predict';

import { MobileNavBarScaffold } from '../../app/components/responsive/mobile-navbar-scaffold';
import { SettingsContainer } from '../../settings/components/settings-container';
import { usePermissions } from '../../hooks/usePermissions';

import { MobileMenuDrawer } from '../../app/components/responsive/mobile-menu-drawer';
import { HelpList } from '../../help/components/help-list';

export const ProductsNavbarMobile = () => {
  const { workspaceId: tempWorkspaceId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const { displayGlobalNav } = useSxpContext();
  const permissions = usePermissions();

  if (displayGlobalNav) {
    return null;
  }

  return (
    <MobileNavBarScaffold
      right={
        <MobileMenuDrawer
          menuItems={[
            <SettingsContainer key="settingsContainerId" permissions={permissions || []} workspaceId={workspaceId} />,
            <HelpList key="helpListComponentId" />
          ]}
        />
      }
    />
  );
};
